<template>
  <div
    v-if="breadcrumbs.length > 1"
    class="d-flex container"
    style="display: grid !important; margin-top: 0px">
    <div class="breadcrumb-items">
      <div
        v-for="(item, i) in breadcrumbs"
        class="breadcrumb-item-outer"
        @click="jumpToBreadcrumb(item['object'])">
        <div class="breadcrumb-item">
          <div v-if="item?.portLabel">
            <div class="breadcrumb-item__name">
              {{ item?.portLabel }}
            </div>
            <div
              class="breadcrumb-item__name breadcrumb-item__name_small"
              style="font-size: 11px">
              <v-icon class="mr-2">{{ GetLogo(item['uid']) }}</v-icon>
              {{ item['name'] }}
            </div>
          </div>
          <div v-else-if="item.tabname">
            <div class="breadcrumb-item__name">
              {{ item?.tabname }}
            </div>
            <div
              class="breadcrumb-item__name breadcrumb-item__name_small"
              style="font-size: 11px">
              <v-icon class="mr-2">{{ GetLogo(item['uid']) }}</v-icon>
              {{ item['name'] }}
            </div>
          </div>
          <div v-else>
            <div class="breadcrumb-item__name">
              <v-icon class="mr-2">{{ GetLogo(item['uid']) }}</v-icon>
              {{ item['name'] }}
            </div>
          </div>
        </div>
        <v-icon
          v-if="i < breadcrumbs?.length - 1"
          class="mx-2 chevron-illusion">
          mdi-chevron-right
        </v-icon>
      </div>
    </div>
  </div>
</template>
<script setup>
import { deluge } from '@/stores/deluge.js';
const props = defineProps([
  'topObj',
  'currentObj',
  'currentTemplate',
  'templateUid',
  'breadcrumbs',
  'breadcrumbBack',
  'jumpToBreadcrumb',
  'sceneDataResetToSourceFunc',
  'sceneDataResetFunc',
]);
function GetLogo(scene_name) {
  for (const template in deluge.templates) {
    if (template == scene_name) {
      return deluge.templates[template].icon;
    }
  }
  return 'mdi-cube';
}
function getSceneDataDepth(sceneData) {
  let counter = 0;

  for (const key in sceneData) {
    const thisObj = sceneData[key];

    if (thisObj['scene_data']) {
      counter++;
      const result = getSceneDataDepth(thisObj['scene_data']);
      counter += result;
    }
  }
  return counter;
}
</script>
<style scoped>
.container {
  margin: 1rem 0;
  display: flex;
  flex-direction: column;
}
.breadcrumb-items {
  display: flex;
  align-items: end;
  border-radius: 10px;
  overflow: hidden;
  overflow-x: auto;
}

.breadcrumb-item {
  padding: 15px 23px 15px 23px;
  position: relative;
  display: inline-block;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
}

.breadcrumb-item-outer:hover .breadcrumb-item {
  opacity: 0.5;
}

.breadcrumb-item-outer:hover {
  cursor: pointer;
}

.breadcrumb-item:last-child {
  color: rgb(var(--v-theme-primary));
}

.breadcrumb-item-outer:last-child {
  padding-right: 15px;
  clip-path: polygon(85% 0, 100% 50%, 85% 100%, 0 100%, 0 0);
}

.breadcrumb-item__port-label {
  position: relative;
  top: -5px;
  line-height: 0;
  text-decoration: none;
  font-size: 12px;
  opacity: var(--v-medium-emphasis-opacity);
}

.breadcrumb-item-outer {
  background-color: var(--inner-background);
  min-width: 200px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  padding-right: 25px;
  height: 60px;
  position: relative;
}

.breadcrumb-item__name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  max-width: 200px;
  text-align: left;
  font-weight: 600;
}

.breadcrumb-item__name_small {
  font-weight: 100;
}

.chevron-illusion {
  opacity: 1.7;
  color: rgb(var(--v-theme-surface));
  z-index: 1;
  pointer-events: none;
  transform-origin: center center;
  font-size: 160px;
  position: absolute;
  right: -70px;
}
</style>
